import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseTag } from '../components/base-tag/Component.js';

var defaultColors = {"filled":"tag__filled_cf0sv"};
require('./default.desktop.css')

var styles = {"rectangular":"tag__rectangular_1r5m1","size-32":"tag__size-32_1r5m1","size-40":"tag__size-40_1r5m1","size-48":"tag__size-48_1r5m1","size-56":"tag__size-56_1r5m1","size-64":"tag__size-64_1r5m1","size-72":"tag__size-72_1r5m1"};
require('./desktop.css')

var invertedColors = {"filled":"tag__filled_g9yyq"};
require('./inverted.desktop.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var TagDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BaseTag, __assign({}, restProps, { colorStylesMap: colorStyles, ref: ref, styles: styles }))); });

export { TagDesktop };
